export default {"src":"/_next/static/media/dollar-sign.e4e13b04.svg","height":512,"width":288,"blurWidth":0,"blurHeight":0};